// export const baseUrl = 'http://localhost:8000/api';
// export const baseUrl = 'https://teledoc.co.in/backend/api';
// export const baseUrl = 'https://dev.teledoc.co.in/backend/api';
export const baseUrl = 'https://teledoc.co.in/backend/api';
// export const baseUrl = 'http://localhost:8000/api';
// export const baseUrl = 'http://192.168.29.191/teledoc/api/';